import { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Download } from 'lucide-react';
import { adminGetBlob, downloadBlob } from '../adminApi';
import { Btn, Input, Page, Table, fmt, sGet } from './staffShared';

export default function AuditLogPage() {
  const [rows, setRows] = useState([]);
  const [f, setF] = useState({ action: '', object_type: '', date_from: '', date_to: '' });
  const set = (k) => (v) => setF(s => ({ ...s, [k]: v }));
  const qs = () => new URLSearchParams(Object.fromEntries(Object.entries(f).filter(([, v]) => v))).toString();
  const load = useCallback(() => sGet(`/audit-log?${qs()}`).then(setRows).catch(e => toast.error(e.message)), [f]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [load]);
  const exportCsv = async () => { try { downloadBlob(await adminGetBlob(`/audit-log/export?${qs()}`), 'audit-log.csv'); } catch (e) { toast.error(e.message); } };
  return (
    <Page title="Audit log" sub="Append-only. Every staff mutation is written in the same transaction as the change." testId="audit-log-page"
      action={<Btn onClick={exportCsv} testId="audit-export"><Download size={14} className="inline mr-1" />CSV (scope-limited)</Btn>}>
      <div className="grid gap-3 md:grid-cols-4">
        <Input label="Action contains" value={f.action} onChange={set('action')} testId="audit-f-action" />
        <Input label="Object type" value={f.object_type} onChange={set('object_type')} testId="audit-f-object" placeholder="staff_user, tenant, category…" />
        <Input label="From" value={f.date_from} onChange={set('date_from')} testId="audit-f-from" type="datetime-local" />
        <Input label="To" value={f.date_to} onChange={set('date_to')} testId="audit-f-to" type="datetime-local" />
      </div>
      <Table testId="audit-table" cols={['At', 'Actor', 'Role', 'Action', 'Object', 'IP', 'Change']} widths={['13%', '16%', '9%', '18%', '22%', '10%', '12%']} rows={rows} render={r => (
        <tr key={r.id} className="border-t align-top" style={{ borderColor: '#F3F1EA' }} data-testid={`audit-row-${r.id}`}>
          <td className="px-3 py-2 text-xs">{fmt(r.at)}</td>
          <td className="px-3 py-2 text-xs break-words">{r.actor_name || r.actor_id?.slice(0, 8) || 'system'}</td>
          <td className="px-3 py-2 text-xs break-words">{r.actor_role || '—'}</td>
          <td className="px-3 py-2 font-mono text-xs break-all">{r.action}</td>
          <td className="px-3 py-2 font-mono text-xs break-all">{r.object_type}:{(r.object_id || '').slice(0, 13)}</td>
          <td className="px-3 py-2 font-mono text-xs break-all">{r.ip || '—'}</td>
          <td className="px-3 py-2 text-xs"><details><summary className="cursor-pointer" style={{ color: '#6b7069' }}>before / after</summary>
            <pre className="text-[10px] whitespace-pre-wrap break-all">{JSON.stringify({ before: r.before, after: r.after }, null, 1)}</pre></details></td>
        </tr>
      )} />
    </Page>
  );
}
